import { Notification } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { NotificationDomain } from 'application/common/model/notification-domain';

export abstract class AppPushApiPort {
	public abstract observeDomainMessage<T>(
		domain: NotificationDomain
	): Observable<Notification<NotificationDomain, T>>;

	public abstract observeWebsocketChanges(): Observable<boolean>;
}
